export default "__VITE_ASSET__D8FN44n7__"